import { Tasks } from "@components/modules/resource-planning/tasks";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationTasks } from "@src/components/widgets/AppSubNav/NavigationTasks/NavigationTasks";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    fullWidth
    noGutters
    noTopMargin
    noBottomMargin
    title={t`My watched tasks`}
    navigation={<NavigationTasks variant="page" />}
  >
    <DemoModule module={Modules.Projects}>
      <Tasks variant="my-watched" />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/tasks/my-watched/")({
  component: Page,
});
